import React, { useEffect, useRef } from "react";
import "./Experience.css";

const items = [
  {
    title: "Disegno Web Bologna",
    role: "Co-Ceo | Diseño & Web Development / Marketing",
    date: "2015 - Actualidad",
    img: "https://www.disegnowebologna.com/wp-content/uploads/2021/04/logo_dwb-1.png.webp",
    url: "https://www.disegnowebologna.com/"
  },
  {
    title: "WM sas",
    role: "Freelance | Web Development e SEO manager",
    date: "2022 - Actualidad",
    img: "logo-WM-sas-2022-ombra.png",
    url: "https://webmarketingconsulenza.com/"
  },
  {
    title: "25 Watts",
    role: "Freelance | Diseño & Web Development",
    date: "2019 - Actualidad",
    img: "https://25watts.com.ar/assets/img/logo-25w-white.svg",
    url: "https://www.25watts.com.ar/"
  }
];

function ExperienceStack() {
  const containerRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
	  const cards = containerRef.current.querySelectorAll(".exp-card");

	  const handleScroll = () => {
		  const section = sectionRef.current;
		  const cards = containerRef.current.querySelectorAll(".exp-card");

		  const rect = section.getBoundingClientRect();
		  const windowHeight = window.innerHeight;

		  const progress = Math.min(
			Math.max((windowHeight - rect.top) / (windowHeight + rect.height), 0),
			1
		  );

		  cards.forEach((card, index) => {
			const total = cards.length;
			const start = index / total;
			const end = (index + 1) / total;

			if (progress >= start && progress < end) {
			  // ACTIVO
			  card.style.opacity = "1";
			  card.style.transform = "translateY(0px) scale(1)";
			  card.style.zIndex = 10;
			} 
			else if (progress >= end) {
			  // DESAPARECE HACIA ARRIBA (fade out)
			  card.style.opacity = "0";
			  card.style.transform = "translateY(-80px) scale(0.95)";
			  card.style.zIndex = 5;
			} 
			else {
			  // ENTRADA DESDE ABAJO
			  card.style.opacity = "0";
			  card.style.transform = "translateY(80px) scale(0.95)";
			  card.style.zIndex = 1;
			}
		  });
	  };

	  window.addEventListener("scroll", handleScroll);
	  handleScroll();

	  return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
  <section className="experience-section" ref={sectionRef}>
    <div className="exp-container" ref={containerRef}>
      {items.map((item, i) => (
        <div className="exp-card" key={i}>
          <div className="exp-content">
            <a href={item.url} target="_blank" rel="noreferrer">
              <img src={item.img} alt={item.title} />
            </a>
            <h2>{item.title}</h2>
            <span>{item.role}</span>
            <p>{item.date}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
  );
}

export default ExperienceStack;